import { Group, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

type MailSelectAllBannerProps = {
  pageCount: number;
  totalCount: number;
  isSelectAllPages: boolean;
  onToggle: () => void;
};

export const MailSelectAllBanner = ({
  pageCount,
  totalCount,
  isSelectAllPages,
  onToggle,
}: MailSelectAllBannerProps) => {
  const { t } = useTranslation();

  const selectedCount = isSelectAllPages ? totalCount : pageCount;
  const toggleCount = isSelectAllPages ? pageCount : totalCount;

  return (
    <Group justify="center" gap={4} py="xs" bg="blue.0">
      <Text size="xs">
        {t(selectedCount === 1 ? i18nKeys.SELECTED_ELEMENT : i18nKeys.SELECTED_ELEMENTS, {
          count: selectedCount,
        })}
      </Text>
      <Text
        size="xs"
        c="blue"
        style={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={onToggle}
      >
        {t(toggleCount === 1 ? i18nKeys.SELECT_ELEMENT : i18nKeys.SELECT_ELEMENTS, {
          count: toggleCount,
        })}
      </Text>
    </Group>
  );
};
